{
  "name": "@ns/support-autopay-card-detach-failed",
  "version": "1.0.0",
  "description": "A company's automatic payments card was changed, but its old card couldn't be removed at Stripe (#25 phase 6, G13): the change stands. The SUPPORT team removes the old card by hand in the Stripe dashboard (the customer link is on the card), then marks it resolved. One open per company and old payment method.",
  "inputs": {},
  "outcomes": {
    "resolved": {}
  }
}
